<template>
  <!--客户案例 客户logo-->
  <div class="zj_classiccustomerLogo box_shadow1">
    <div
      class="title1 flexcc font16rem wow bounceIn"
      data-wow-duration="2s"
      data-wow-delay="0s"
      data-wow-offset="10"
      data-wow-iteration="1"
    >
     {{$t('持续创新赋能 助力品牌成长')}} 
    </div>
    <div
      class="title2 flexcc font10rem wow bounceIn"
      data-wow-duration="2s"
      data-wow-delay="0s"
      data-wow-offset="10"
      data-wow-iteration="1"
    >
      {{$t('十六年的技术和服务沉淀 成就知名品牌坚定选择')}}
    </div>
    <div class="customerLogo">
      <div
        class="logo flexcc wow"
        v-for="item in logodata"
        :key="item.index"
        :class="
          item.index <= 4 || (item.index >= 9 && item.index <= 12)
            ? 'bounceInLeft'
            : 'bounceInRight'
        "
        data-wow-duration="2s"
        data-wow-delay="0s"
        data-wow-offset="10"
        data-wow-iteration="1"
      >
        <img :src="item.pic" />
      </div>
    </div>
  </div>
</template>

<script>
//import {WOW} from 'wowjs'
import Swiper from "swiper";
export default {
  name: "zj_classiccustomerLogo",
  data() {
    return {
      logodata: [
        {
          index: 2,
          name: "fila",
          pic: require("../assets/Images/brand/fila.png"),
        },
        {
          index: 3,
          name: "安踏",
          pic: require("../assets/Images/brand/anta.png"),
        },
        {
          index: 16,
          name: "九木",
          pic: require("../assets/Images/brand/jm.png"),
        },
        {
          index: 4,
          name: "木槿",
          pic: require("../assets/Images/brand/mumuso.png"),
        },
        {
          index: 5,
          name: "可隆",
          pic: require("../assets/Images/brand/kolon.png"),
        },
        {
          index: 6,
          name: "小笑牛",
          pic: require("../assets/Images/brand/kingkow.png"),
        },
        {
          index: 7,
          name: "迪桑特",
          pic: require("../assets/Images/brand/descente.png"),
        },
        {
          index: 8,
          name: "amersports",
          pic: require("../assets/Images/brand/amersports.png"),
        },
        {
          index: 9,
          name: "suunto",
          pic: require("../assets/Images/brand/suunto.png"),
        },
        {
          index: 10,
          name: "precor",
          pic: require("../assets/Images/brand/precor.png"),
        },
        {
          index: 11,
          name: "peakperformance",
          pic: require("../assets/Images/brand/peakperformance.png"),
        },
        {
          index: 12,
          name: "始祖鸟",
          pic: require("../assets/Images/brand/arcteryx.png"),
        },
        // {
        //   index: 13,
        //   name: "萨洛蒙",
        //   pic: require("../assets/Images/brand/salomon.png"),
        // },
        {
          index: 1,
          name: "波司登",
          pic: require("../assets/Images/brand/bsd.png"),
        },
        {
          index: 14,
          name: "绿叶",
          pic: require("../assets/Images/brand/ly.png"),
        },
        {
          index: 15,
          name: "阿仕顿",
          pic: require("../assets/Images/brand/artsdon.png"),
        },
        {
          index: 17,
          name: "delicates",
          pic: require("../assets/Images/brand/delicates.png"),
        },
      ],
    };
  },
  watch: {},
  mounted() {
    new this.$wow.WOW({ live: false }).init();
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.zj_classiccustomerLogo {
  width: 70%;
  height: 100%;
  margin: auto;
  .title1 {
    width: 100%;
    height: 4rem;
    padding-top: 2rem;
  }
  .title2 {
    width: 100%;
    height: 2rem;
  }
  .customerLogo {
    width: 95%;
    height: 80%;
    margin-left: 4%;
    .logo {
      width: 22.5%;
      height: 6rem;
      float: left;
      margin: 2% 2.5% 0 0;
      img {
        width: 45%;
      }
    }
  }
}
</style>
